<template>
  <el-dialog :title="titleName" :visible.sync="dialogFormVisible">
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <el-input v-model="form.deptId" autocomplete="off" style="display: none;"></el-input>
      <el-input v-model="form.parentId" autocomplete="off" style="display: none;"></el-input>
      <el-form-item label="上级部门：" :label-width="formLabelWidth">
        <el-input v-model="form.parentName" autocomplete="off" :disabled="parentNameBool"></el-input>
      </el-form-item>
      <el-form-item label="部门名称：" :label-width="formLabelWidth" :required="true" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="排列序号：" :label-width="formLabelWidth" :required="true" prop="orderNum" style="text-align: left">
        <el-input-number v-model="form.orderNum" controls-position="right" :min="1" :max="100"></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogFormVisible: true,
        parentNameBool: true,
        titleName: '',
        url: '',
        form: {
          deptId: '',
          parentId: '',
          parentName: '',
          name: '',
          orderNum: ''
        },
        rules: {
          name: [{required: true, message: '请输入部门名称', trigger: 'blur'}],
          orderNum: [{required: true, message: '请输入排列序号', trigger: 'blur'}]
        },
        formLabelWidth: '120px'
      };
    },
    methods: {
      int(deptId,name,status) {

        this.form.deptId = '';
        this.form.name = '';
        this.form.orderNum = '';
        this.form.parentId = '';
        this.form.parentName = '';
        this.$refs['ruleForm'].resetFields();

        if(status==1) {
          this.url = "/business/system/sysDept/update";
          this.titleName = "部门管理-修改";

          this.$httpTAG({
            url: this.$httpTAG.adornUrl('/business/system/sysDept/view'),
            method: 'post',
            data: this.$httpTAG.adornData({
              'deptId': deptId
            })
          }).then(r => {
            this.form = r.data.data;
          }).finally(r => {})

        }else if(status==2){
          this.form.parentId = deptId;
          this.form.parentName = name;
          this.url = "/business/system/sysDept/save";
          this.titleName = "部门管理-新增下级";
        }else if(status==3){
          this.form.parentName = '无';
          this.url = "/business/system/sysDept/save";
          this.titleName = "部门管理-新增";
        }

        this.dialogFormVisible = true;
      },
      addAndUpdate(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {

            this.$httpTAG({
              url: this.$httpTAG.adornUrl(this.url),
              method: 'post',
              data: this.$httpTAG.adornData({
                'deptId': this.form.deptId,
                'parentId': this.form.parentId,
                'parentName': this.form.parentName,
                'name': this.form.name,
                'orderNum': this.form.orderNum

              })
            }).then(res => {
              if (res.data.code == 0) {
                this.$notify({
                  title: '操作成功！',
                  type: 'success',
                  offset: 600
                });
                this.dialogFormVisible = false
                this.$emit("handleCurrentChange","1");
              } else {
                this.$message({ // 失败
                  type: 'fail',
                  message: res.data.msg
                })
              }
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  };
</script>

<style scoped>
</style>
